// LOGINLOOP-1 — the `next` search-param a /login bounce carries must REUSE
// an existing `next` from the current URL, never re-wrap it: wrapping nests
// one level deeper on every bounce (`/?next=%2F` -> `/login?next=%2F%3Fnext
// %3D%252F` -> ... byte-for-byte the reported URL). Extracted from
// packages/workspace/app.js's `_authRouteGuard` — the one call site that
// already got this right and is unit-tested for it
// (authGuardNextNesting.test.js) — so a SECOND site (bootShell.js's
// `_forceLogoutAndReauth`, which built `next` from
// `window.location.search` verbatim with no unwrap at all) has one proven
// implementation to converge on instead of drifting its own copy.
//
// app.js's guard CALLS this too now (2026-09-20) — it kept the last inline
// copy for a while, because that guard's TIMING (`_authReady`/`signedIn`
// checks, when it fires) has its own reverted-loop precedent (2026-07-20,
// iPad). Only the URL arithmetic moved here; the timing stayed where it was.
// packages/workspace/functions/authGuardNextNesting.test.js drives this
// function composed exactly as app.js composes it.
//
// Returns the RAW (un-encoded) next value, or null when the resolved
// bounce target is bare `/` with no meaningful query — a plain `/login` is
// correct there, not `/login?next=%2F`. Callers encode at the point of
// URL insertion, matching the existing convention in every caller this
// was extracted from.
export const resolveAuthNext = (pathname, search) => {
  const params = new URLSearchParams(search || '')
  let carried = params.get('next')
  if (carried) {
    // Unwrap REPEATEDLY, not once — a URL nested two deep still contains a
    // `next` after a single unwrap, and the loop survives (this is what
    // caught the first attempt at this fix in app.js: see
    // authGuardNextNesting.test.js's fixed-point test). Bounded to avoid
    // spinning on a hand-crafted URL.
    for (let i = 0; i < 8; i++) {
      const q = carried.split('?')[1]
      if (!q) break
      const inner = new URLSearchParams(q).get('next')
      if (!inner) break
      carried = inner
    }
    return carried
  }
  params.delete('next')
  const query = params.toString()
  const dest = pathname + (query ? `?${query}` : '')
  return dest === '/' ? null : dest
}
